export class UserUpdate
{
    storeid: string;
    accounttype: string;
    userstore: string;
    role: string;
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/userupdatemodel.ts